import { useWebsite } from '../../../front/src/hooks/useWebsite';
import type { Website } from '../../../front/src/types/api';

// Legacy NextCircle (renamed from AlphaCircle on 2026-05-11) is gated by website _id
// rather than public_key, because the key was migrated alongside the rename. Aligned
// with the same approach in api/src/controllers/website_controller.js:8206.
export const ALPHACIRCLE_LEGACY_WEBSITE_ID = '62543bba4d5a254dd5d88c46';
const TEST_DEBATE_KEY = 'MyApp';

function isAlphaCircleLegacy(websiteId: string | null | undefined) {
  return websiteId === ALPHACIRCLE_LEGACY_WEBSITE_ID;
}

function isAlphaCircleOrTestDebate(websiteId: string | null | undefined, key: string) {
  return isAlphaCircleLegacy(websiteId) || key === TEST_DEBATE_KEY;
}

export function useIsAlphaCircleOrTestDebate() {
  const { id, key } = useWebsite();
  return isAlphaCircleOrTestDebate(id, key);
}

export function useHasAds() {
  // We temporarily disable ads to boost SEO
  return /* !useIsAlphaCircleOrTestDebate() */ false;
}

export function useAreGroupsEnabled() {
  return checkGroupsEnabled(useWebsite());
}

export function checkGroupsEnabled(website: Website) {
  return website.graphdebate?.group || false;
}

export function deepCopy<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj) as T;
  }

  if (Array.isArray(obj)) {
    const arrCopy: any[] = [];
    for (const item of obj) {
      arrCopy.push(deepCopy(item));
    }
    return arrCopy as T;
  }

  if (obj instanceof Map) {
    const mapCopy = new Map();
    for (const [key, value] of obj) {
      mapCopy.set(key, deepCopy(value));
    }
    return mapCopy as T;
  }

  if (obj instanceof Set) {
    const setCopy = new Set();
    for (const item of obj) {
      setCopy.add(deepCopy(item));
    }
    return setCopy as T;
  }

  const objCopy = {} as Partial<T>;
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      objCopy[key] = deepCopy(obj[key]);
    }
  }
  return objCopy as T;
}
